import React from 'react';
import { useTranslation } from 'react-i18next';

import {ReactComponent as ArrowNextIcon} from '../../../shared/icons/arrow-next-icon.svg';
import {ReactComponent as ArrowPreviousIcon} from '../../../shared/icons/arrow-previous-icon.svg';
import './DateCarouselItem.scss';

const DateCarouselItem = (props) => {
  const {value, onPreviousClick, onNextClick, className} = props;
  const { i18n } = useTranslation();
  const isRtl = i18n.language === 'heb';

  const startButton = isRtl
    ? { onClick: onNextClick, icon: <ArrowNextIcon/> }
    : { onClick: onPreviousClick, icon: <ArrowPreviousIcon/> };

  const endButton = isRtl
    ? { onClick: onPreviousClick, icon: <ArrowPreviousIcon/> }
    : { onClick: onNextClick, icon: <ArrowNextIcon/> };

  return <div className={`date-carousel-item-wrapper ${className||""}`}>
    <div className="date-carousel-item-button" onClick={startButton.onClick}>{startButton.icon}</div>
    <div className="date-carousel-item-value">{value}</div>
    <div className="date-carousel-item-button" onClick={endButton.onClick}>{endButton.icon}</div>
  </div>
}

export default DateCarouselItem;